var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncompleteFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0819 8.53277C15.0819 12.4441 11.9113 15.6147 7.99994 15.6147C4.08862 15.6147 0.917969 12.4441 0.917969 8.53277C0.917969 4.62146 4.08862 1.45081 7.99994 1.45081C11.9113 1.45081 15.0819 4.62146 15.0819 8.53277Z",
    fill: "#E2E2E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25616 11.9754C7.0341 11.9754 6.81083 11.9051 6.6227 11.7614L3.6829 8.7715C3.22898 8.42501 3.1448 7.77982 3.49498 7.33053C3.84504 6.88136 4.49689 6.79804 4.95081 7.14453L7.13023 9.55405L10.7166 5.62545C11.1009 5.20447 11.7572 5.17153 12.1826 5.55204C12.608 5.93233 12.6412 6.58203 12.2568 7.00301L8.02677 11.6368C7.82275 11.8602 7.54044 11.9754 7.25616 11.9754Z",
    fill: "#FFFDFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncompleteFolder);
export default __webpack_public_path__ + "static/media/incomplete_folder.7c97e363bb674476619193cf3df7516c.svg";
export { ForwardRef as ReactComponent };